import { OrderStates } from 'modules/orders/types'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { axios } from '../../../lib'

const loadStates = (data: PaginatedParams): PaginatedResponse<OrderStates> => {
  const { page = 1, limit = 100 } = data
  return axios.get('/orders/generals/states', {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadCustomerStates(query: any) {
  return useQuery(['customerStates', query], () => loadStates(query), {
    keepPreviousData: true,
    onError: () =>
      toast.error('Não foi possível carregar os estados!', {
        toastId: 'loadCustomerStates'
      })
  })
}
